import moment from 'moment'
import { Tooltip } from '@clickguard/design-system'

export const GDateTime = (props: {
	date?: Date | null
	time?: boolean
	className?: string
}) => {
	const { date, time = true, className } = props

	const format = `MMMM Do, YYYY${time ? ' - hh:mm:ss A' : ''}`
	if (!date) return <span>N/A</span>

	return (
		<Tooltip position="top" content={moment(date).format(format)}>
			<span className={className || ''}>{moment(date).fromNow()}</span>
		</Tooltip>
	)
}
